import { selectIcon } from "../components/UI/selector";

export const version = "6.7.23c";

export const states = [
  {
    label: "Alabama",
    value: "AL",
  },
  {
    label: "Alaska",
    value: "AK",
  },
  {
    label: "American Samoa",
    value: "AS",
  },
  {
    label: "Arizona",
    value: "AZ",
  },
  {
    label: "Arkansas",
    value: "AR",
  },
  {
    label: "California",
    value: "CA",
  },
  {
    label: "Colorado",
    value: "CO",
  },
  {
    label: "Connecticut",
    value: "CT",
  },
  {
    label: "Delaware",
    value: "DE",
  },
  {
    label: "District Of Columbia",
    value: "DC",
  },
  {
    label: "Federated States Of Micronesia",
    value: "FM",
  },
  {
    label: "Florida",
    value: "FL",
  },
  {
    label: "Georgia",
    value: "GA",
  },
  {
    label: "Guam",
    value: "GU",
  },
  {
    label: "Hawaii",
    value: "HI",
  },
  {
    label: "Idaho",
    value: "ID",
  },
  {
    label: "Illinois",
    value: "IL",
  },
  {
    label: "Indiana",
    value: "IN",
  },
  {
    label: "Iowa",
    value: "IA",
  },
  {
    label: "Kansas",
    value: "KS",
  },
  {
    label: "Kentucky",
    value: "KY",
  },
  {
    label: "Louisiana",
    value: "LA",
  },
  {
    label: "Maine",
    value: "ME",
  },
  {
    label: "Marshall Islands",
    value: "MH",
  },
  {
    label: "Maryland",
    value: "MD",
  },
  {
    label: "Massachusetts",
    value: "MA",
  },
  {
    label: "Michigan",
    value: "MI",
  },
  {
    label: "Minnesota",
    value: "MN",
  },
  {
    label: "Mississippi",
    value: "MS",
  },
  {
    label: "Missouri",
    value: "MO",
  },
  {
    label: "Montana",
    value: "MT",
  },
  {
    label: "Nebraska",
    value: "NE",
  },
  {
    label: "Nevada",
    value: "NV",
  },
  {
    label: "New Hampshire",
    value: "NH",
  },
  {
    label: "New Jersey",
    value: "NJ",
  },
  {
    label: "New Mexico",
    value: "NM",
  },
  {
    label: "New York",
    value: "NY",
  },
  {
    label: "North Carolina",
    value: "NC",
  },
  {
    label: "North Dakota",
    value: "ND",
  },
  {
    label: "Northern Mariana Islands",
    value: "MP",
  },
  {
    label: "Ohio",
    value: "OH",
  },
  {
    label: "Oklahoma",
    value: "OK",
  },
  {
    label: "Oregon",
    value: "OR",
  },
  {
    label: "Palau",
    value: "PW",
  },
  {
    label: "Pennsylvania",
    value: "PA",
  },
  {
    label: "Puerto Rico",
    value: "PR",
  },
  {
    label: "Rhode Island",
    value: "RI",
  },
  {
    label: "South Carolina",
    value: "SC",
  },
  {
    label: "South Dakota",
    value: "SD",
  },
  {
    label: "Tennessee",
    value: "TN",
  },
  {
    label: "Texas",
    value: "TX",
  },
  {
    label: "Utah",
    value: "UT",
  },
  {
    label: "Vermont",
    value: "VT",
  },
  {
    label: "Virgin Islands",
    value: "VI",
  },
  {
    label: "Virginia",
    value: "VA",
  },
  {
    label: "Washington",
    value: "WA",
  },
  {
    label: "West Virginia",
    value: "WV",
  },
  {
    label: "Wisconsin",
    value: "WI",
  },
  {
    label: "Wyoming",
    value: "WY",
  },
];

export const countries = [
  { value: "US", label: "United States" },
  { value: "GB", label: "United Kingdom" },
  { value: "CA", label: "Canada" },
  { value: "AF", label: "Afghanistan" },
  { value: "AX", label: "Aland Islands" },
  { value: "AL", label: "Albania" },
  { value: "DZ", label: "Algeria" },
  { value: "AS", label: "American Samoa" },
  { value: "AD", label: "Andorra" },
  { value: "AO", label: "Angola" },
  { value: "AI", label: "Anguilla" },
  { value: "AQ", label: "Antarctica" },
  { value: "AG", label: "Antigua And Barbuda" },
  { value: "AR", label: "Argentina" },
  { value: "AM", label: "Armenia" },
  { value: "AN", label: "Netherlands Antilles" },
  { value: "AW", label: "Aruba" },
  { value: "AU", label: "Australia" },
  { value: "AT", label: "Austria" },
  { value: "AZ", label: "Azerbaijan" },
  { value: "BS", label: "Bahamas" },
  { value: "BH", label: "Bahrain" },
  { value: "BD", label: "Bangladesh" },
  { value: "BB", label: "Barbados" },
  { value: "BY", label: "Belarus" },
  { value: "BE", label: "Belgium" },
  { value: "BZ", label: "Belize" },
  { value: "BJ", label: "Benin" },
  { value: "BM", label: "Bermuda" },
  { value: "BT", label: "Bhutan" },
  { value: "BO", label: "Bolivia" },
  { value: "BA", label: "Bosnia And Herzegovina" },
  { value: "BW", label: "Botswana" },
  { value: "BV", label: "Bouvet Island" },
  { value: "BR", label: "Brazil" },
  { value: "IO", label: "British Indian Ocean Territory" },
  { value: "BN", label: "Brunei Darussalam" },
  { value: "BG", label: "Bulgaria" },
  { value: "BF", label: "Burkina Faso" },
  { value: "BI", label: "Burundi" },
  { value: "KH", label: "Cambodia" },
  { value: "CM", label: "Cameroon" },
  { value: "CA", label: "Canada" },
  { value: "CV", label: "Cape Verde" },
  { value: "KY", label: "Cayman Islands" },
  { value: "CF", label: "Central African Republic" },
  { value: "TD", label: "Chad" },
  { value: "CL", label: "Chile" },
  { value: "CN", label: "China" },
  { value: "CX", label: "Christmas Island" },
  { value: "CC", label: "Cocos (Keeling) Islands" },
  { value: "CO", label: "Colombia" },
  { value: "KM", label: "Comoros" },
  { value: "CG", label: "Congo" },
  { value: "CD", label: "Congo, Democratic Republic" },
  { value: "CK", label: "Cook Islands" },
  { value: "CR", label: "Costa Rica" },
  { value: "CI", label: "Cote D'Ivoire" },
  { value: "HR", label: "Croatia" },
  { value: "CU", label: "Cuba" },
  { value: "CY", label: "Cyprus" },
  { value: "CZ", label: "Czech Republic" },
  { value: "DK", label: "Denmark" },
  { value: "DJ", label: "Djibouti" },
  { value: "DM", label: "Dominica" },
  { value: "DO", label: "Dominican Republic" },
  { value: "EC", label: "Ecuador" },
  { value: "EG", label: "Egypt" },
  { value: "SV", label: "El Salvador" },
  { value: "GQ", label: "Equatorial Guinea" },
  { value: "ER", label: "Eritrea" },
  { value: "EE", label: "Estonia" },
  { value: "ET", label: "Ethiopia" },
  { value: "FK", label: "Falkland Islands (Malvinas)" },
  { value: "FO", label: "Faroe Islands" },
  { value: "FJ", label: "Fiji" },
  { value: "FI", label: "Finland" },
  { value: "FR", label: "France" },
  { value: "GF", label: "French Guiana" },
  { value: "PF", label: "French Polynesia" },
  { value: "TF", label: "French Southern Territories" },
  { value: "GA", label: "Gabon" },
  { value: "GM", label: "Gambia" },
  { value: "GE", label: "Georgia" },
  { value: "DE", label: "Germany" },
  { value: "GH", label: "Ghana" },
  { value: "GI", label: "Gibraltar" },
  { value: "GR", label: "Greece" },
  { value: "GL", label: "Greenland" },
  { value: "GD", label: "Grenada" },
  { value: "GP", label: "Guadeloupe" },
  { value: "GU", label: "Guam" },
  { value: "GT", label: "Guatemala" },
  { value: "GG", label: "Guernsey" },
  { value: "GN", label: "Guinea" },
  { value: "GW", label: "Guinea-Bissau" },
  { value: "GY", label: "Guyana" },
  { value: "HT", label: "Haiti" },
  { value: "HM", label: "Heard Island & Mcdonald Islands" },
  { value: "VA", label: "Holy See (Vatican City State)" },
  { value: "HN", label: "Honduras" },
  { value: "HK", label: "Hong Kong" },
  { value: "HU", label: "Hungary" },
  { value: "IS", label: "Iceland" },
  { value: "IN", label: "India" },
  { value: "ID", label: "Indonesia" },
  { value: "IR", label: "Iran, Islamic Republic Of" },
  { value: "IQ", label: "Iraq" },
  { value: "IE", label: "Ireland" },
  { value: "IM", label: "Isle Of Man" },
  { value: "IL", label: "Israel" },
  { value: "IT", label: "Italy" },
  { value: "JM", label: "Jamaica" },
  { value: "JP", label: "Japan" },
  { value: "JE", label: "Jersey" },
  { value: "JO", label: "Jordan" },
  { value: "KZ", label: "Kazakhstan" },
  { value: "KE", label: "Kenya" },
  { value: "KI", label: "Kiribati" },
  { value: "KR", label: "Korea" },
  { value: "KW", label: "Kuwait" },
  { value: "KG", label: "Kyrgyzstan" },
  { value: "LA", label: "Lao People's Democratic Republic" },
  { value: "LV", label: "Latvia" },
  { value: "LB", label: "Lebanon" },
  { value: "LS", label: "Lesotho" },
  { value: "LR", label: "Liberia" },
  { value: "LY", label: "Libyan Arab Jamahiriya" },
  { value: "LI", label: "Liechtenstein" },
  { value: "LT", label: "Lithuania" },
  { value: "LU", label: "Luxembourg" },
  { value: "MO", label: "Macao" },
  { value: "MK", label: "Macedonia" },
  { value: "MG", label: "Madagascar" },
  { value: "MW", label: "Malawi" },
  { value: "MY", label: "Malaysia" },
  { value: "MV", label: "Maldives" },
  { value: "ML", label: "Mali" },
  { value: "MT", label: "Malta" },
  { value: "MH", label: "Marshall Islands" },
  { value: "MQ", label: "Martinique" },
  { value: "MR", label: "Mauritania" },
  { value: "MU", label: "Mauritius" },
  { value: "YT", label: "Mayotte" },
  { value: "MX", label: "Mexico" },
  { value: "FM", label: "Micronesia, Federated States Of" },
  { value: "MD", label: "Moldova" },
  { value: "MC", label: "Monaco" },
  { value: "MN", label: "Mongolia" },
  { value: "ME", label: "Montenegro" },
  { value: "MS", label: "Montserrat" },
  { value: "MA", label: "Morocco" },
  { value: "MZ", label: "Mozambique" },
  { value: "MM", label: "Myanmar" },
  { value: "NA", label: "Namibia" },
  { value: "NR", label: "Nauru" },
  { value: "NP", label: "Nepal" },
  { value: "NL", label: "Netherlands" },
  { value: "AN", label: "Netherlands Antilles" },
  { value: "NC", label: "New Caledonia" },
  { value: "NZ", label: "New Zealand" },
  { value: "NI", label: "Nicaragua" },
  { value: "NE", label: "Niger" },
  { value: "NG", label: "Nigeria" },
  { value: "NU", label: "Niue" },
  { value: "NF", label: "Norfolk Island" },
  { value: "MP", label: "Northern Mariana Islands" },
  { value: "NO", label: "Norway" },
  { value: "OM", label: "Oman" },
  { value: "PK", label: "Pakistan" },
  { value: "PW", label: "Palau" },
  { value: "PS", label: "Palestinian Territory, Occupied" },
  { value: "PA", label: "Panama" },
  { value: "PG", label: "Papua New Guinea" },
  { value: "PY", label: "Paraguay" },
  { value: "PE", label: "Peru" },
  { value: "PH", label: "Philippines" },
  { value: "PN", label: "Pitcairn" },
  { value: "PL", label: "Poland" },
  { value: "PT", label: "Portugal" },
  { value: "PR", label: "Puerto Rico" },
  { value: "QA", label: "Qatar" },
  { value: "RE", label: "Reunion" },
  { value: "RO", label: "Romania" },
  { value: "RU", label: "Russian Federation" },
  { value: "RW", label: "Rwanda" },
  { value: "BL", label: "Saint Barthelemy" },
  { value: "SH", label: "Saint Helena" },
  { value: "KN", label: "Saint Kitts And Nevis" },
  { value: "LC", label: "Saint Lucia" },
  { value: "MF", label: "Saint Martin" },
  { value: "PM", label: "Saint Pierre And Miquelon" },
  { value: "VC", label: "Saint Vincent And Grenadines" },
  { value: "WS", label: "Samoa" },
  { value: "SM", label: "San Marino" },
  { value: "ST", label: "Sao Tome And Principe" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "SN", label: "Senegal" },
  { value: "RS", label: "Serbia" },
  { value: "SC", label: "Seychelles" },
  { value: "SL", label: "Sierra Leone" },
  { value: "SG", label: "Singapore" },
  { value: "SK", label: "Slovakia" },
  { value: "SI", label: "Slovenia" },
  { value: "SB", label: "Solomon Islands" },
  { value: "SO", label: "Somalia" },
  { value: "ZA", label: "South Africa" },
  { value: "GS", label: "South Georgia And Sandwich Isl." },
  { value: "ES", label: "Spain" },
  { value: "LK", label: "Sri Lanka" },
  { value: "SD", label: "Sudan" },
  { value: "SR", label: "Surilabel" },
  { value: "SJ", label: "Svalbard And Jan Mayen" },
  { value: "SZ", label: "Swaziland" },
  { value: "SE", label: "Sweden" },
  { value: "CH", label: "Switzerland" },
  { value: "SY", label: "Syrian Arab Republic" },
  { value: "TW", label: "Taiwan" },
  { value: "TJ", label: "Tajikistan" },
  { value: "TZ", label: "Tanzania" },
  { value: "TH", label: "Thailand" },
  { value: "TL", label: "Timor-Leste" },
  { value: "TG", label: "Togo" },
  { value: "TK", label: "Tokelau" },
  { value: "TO", label: "Tonga" },
  { value: "TT", label: "Trinidad And Tobago" },
  { value: "TN", label: "Tunisia" },
  { value: "TR", label: "Turkey" },
  { value: "TM", label: "Turkmenistan" },
  { value: "TC", label: "Turks And Caicos Islands" },
  { value: "TV", label: "Tuvalu" },
  { value: "UG", label: "Uganda" },
  { value: "UA", label: "Ukraine" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "GB", label: "United Kingdom" },
  { value: "US", label: "United States" },
  { value: "UM", label: "United States Outlying Islands" },
  { value: "UY", label: "Uruguay" },
  { value: "UZ", label: "Uzbekistan" },
  { value: "VU", label: "Vanuatu" },
  { value: "VE", label: "Venezuela" },
  { value: "VN", label: "Viet Nam" },
  { value: "VG", label: "Virgin Islands, British" },
  { value: "VI", label: "Virgin Islands, U.S." },
  { value: "WF", label: "Wallis And Futuna" },
  { value: "EH", label: "Western Sahara" },
  { value: "YE", label: "Yemen" },
  { value: "ZM", label: "Zambia" },
  { value: "ZW", label: "Zimbabwe" },
];

export const specialities = [
  { name: "Yoga", image: selectIcon("userDummy"), id: 0 },
  { name: "HIIT", image: selectIcon("userDummy"), id: 1 },
  { name: "Martial Arts", image: selectIcon("userDummy"), id: 2 },
  { name: "Running", image: selectIcon("userDummy"), id: 3 },
  { name: "Pilates", image: selectIcon("userDummy"), id: 4 },
  { name: "Boxing", image: selectIcon("userDummy"), id: 5 },
  { name: "Sports", image: selectIcon("userDummy"), id: 6 },
  { name: "Medication", image: selectIcon("userDummy"), id: 7 },
  { name: "Barre", image: selectIcon("userDummy"), id: 8 },
  { name: "Bootcamp", image: selectIcon("userDummy"), id: 9 },
  { name: "Rowing", image: selectIcon("userDummy"), id: 10 },
  { name: "Cycling", image: selectIcon("userDummy"), id: 11 },
  { name: "Dance", image: selectIcon("userDummy"), id: 12 },
  { name: "Outdoors", image: selectIcon("userDummy"), id: 13 },
  { name: "Elliptical", image: selectIcon("userDummy"), id: 14 },
  { name: "Prenatal", image: selectIcon("userDummy"), id: 15 },
  { name: "Spinning", image: selectIcon("userDummy"), id: 16 },
  { name: "Core", image: selectIcon("userDummy"), id: 17 },
];

export const activityType1 = [
  { icon: selectIcon("barre"), name: "Barre", value: "Barre", child: [] },
  {
    icon: selectIcon("bootcamp"),
    name: "Bootcamp",
    value: "Bootcamp",
    child: [],
  },
  {
    icon: selectIcon("boxing"),
    name: "Boxing",
    value: "Boxing",
    child: ["Kickboxing", "MMA", "Total-Body", "Shadow Boxing"],
  },
  {
    icon: selectIcon("calisthenics"),
    name: "Calisthenics",
    value: "Calisthenics",
    child: [],
  },
  {
    icon: selectIcon("cardio"),
    name: "Cardio",
    value: "Cardio",
    child: [
      "Running",
      "Walking",
      "Rowing",
      "Tread",
      "Jump Rope",
      "Swimming",
      "TABATA",
    ],
  },
  {
    icon: selectIcon("celebrity"),
    name: "Celebrity",
    value: "Celebrity",
    child: [],
  },
  { icon: selectIcon("core"), name: "Core", value: "Core", child: [] },
  { icon: selectIcon("cycling"), name: "Cycling", value: "Cycling", child: [] },
  {
    icon: selectIcon("dance"),
    name: "Dance",
    value: "Dance",
    child: ["Pole", "Aerial", "Zumba", "Aero Dance"],
  },
  {
    icon: selectIcon("functional"),
    name: "Functional",
    value: "Functional",
    child: [],
  },
  { icon: selectIcon("hiit"), name: "HIIT", value: "HIIT", child: [] },
  {
    icon: selectIcon("lowerBody"),
    name: "Lower Body",
    value: "Lower Body",
    child: [],
  },
  {
    icon: selectIcon("meditation"),
    name: "Meditation",
    value: "Meditation",
    child: [],
  },
  {
    icon: selectIcon("mobility"),
    name: "Mobility",
    value: "Mobility",
    child: [],
  },
  { icon: selectIcon("other"), name: "Others", value: "Others", child: [] },
  { icon: selectIcon("pilates"), name: "Pilates", value: "Pilates", child: [] },
  {
    icon: selectIcon("seniorFitness"),
    name: "Senior Fitness",
    value: "Senior Fitness",
    child: [],
  },
  { icon: selectIcon("sports"), name: "Sports", value: "Sports", child: [] },
  {
    icon: selectIcon("streching"),
    name: "Stretching",
    value: "Stretching",
    child: [],
  },
  {
    icon: selectIcon("strengths"),
    name: "Strength",
    value: "Strength",
    child: [],
  },
  { icon: selectIcon("toning"), name: "Toning", value: "Toning", child: [] },
  {
    icon: selectIcon("upperBody"),
    name: "Upper Body",
    value: "Upper Body",
    child: [],
  },
  {
    icon: selectIcon("yoga"),
    name: "Yoga",
    value: "Yoga",
    child: [
      "Vinyasa",
      "Restorative",
      "Prenatal",
      "Postnatal",
      "Slow Flow",
      "Ashtanga",
      "Power Yoga",
    ],
  },
];

export const activityType = [
  { name: "Dance", value: "Dance" },
  { name: "Spinning", value: "Spinning" },
  { name: "Cardio", value: "Cardio" },
  { name: "Strength", value: "Strength" },
  { name: "Interval Training", value: "Interval Training" },
  { name: "Martial Arts", value: "Martial Arts" },
  { name: "Mobility", value: "Mobility" },
  { name: "Stretching", value: "Stretching" },
  { name: "Meditation", value: "Meditation" },
  { name: "Yoga", value: "Yoga" },
  { name: "Pilates", value: "Pilates" },
  { name: "Barre", value: "Barre" },
  { name: "Sports", value: "Sports" },
  { name: "Pole and Aerial Arts", value: "Pole and Aerial" },
  { name: "Celebrity", value: "Celebrity" },
  { name: "Others", value: "Others" },
  { name: "Bootcamp", value: "Bootcamp" },
  { name: "Calisthenics", value: "Calisthenics" },
  { name: "Functional", value: "Functional" },
];

export const difficultyLevel = [
  { icon: selectIcon("low"), name: "Beginner", value: "BEGINNER" },
  { icon: selectIcon("medium"), name: "Intermediate", value: "INTERMEDIATE" },
  { icon: selectIcon("high"), name: "Advanced", value: "ADVANCED" },
  {
    icon: selectIcon("noLevel"),
    name: "Not Applicable",
    value: "NOT_APPLICABLE",
  },
];

export const privacy_settings = [
  { name: "Public", value: "PUBLIC" },
  { name: "Member Only", value: "MEMBERS_ONLY" },
  { name: "Private", value: "PASSWORD_PROTECTED" },
];
export const exportFilterSettings = [
  { name: "By Week", value: "week" },
  { name: "By Month", value: "month" },
  { name: "By Year", value: "year" },
];

export const dateStatusOption = [
  { name: "Created On", value: "created_at" },
  { name: "Edited On", value: "updated_at" },
  { name: "Last Used On", value: "last_used_at" },
];

export const activitySetup = [
  { name: "Studio Only (No Video)", value: "PHYSICAL" },
  { name: "Online (With Video)", value: "ONLINE" },
  { name: "Hybrid (In Studio & Online)", value: "HYBRID" },
];

export const booleanCondition = [
  { name: "Yes", value: true },
  { name: "No", value: false },
];

export const equipment = [
  { name: "Mat", value: "Mat" },
  { name: "Dumbbell", value: "Dumbbell" },
  { name: "Kettlebell", value: "Kettlebell" },
  { name: "Barbell", value: "Barbell" },
  { name: "Mobility Stick", value: "Mobility Stick" },
  { name: "Weight Plates", value: "Weight Plates" },
  { name: "Pilates Ring", value: "Pilates Ring" },
  { name: "Yoga Brick", value: "Yoga Brick" },
  { name: "Foam Roller", value: "Foam Roller" },
  { name: "Massage Ball", value: "Massage Ball" },
  { name: "Massage Bar", value: "Massage Bar" },
  { name: "Stability Ball", value: "Stability Ball" },
  { name: "BOSU Ball", value: "BOSU Ball" },
  { name: "Exercise Bike", value: "Exercise Bike" },
  { name: "Treadmill", value: "Treadmill" },
  { name: "Bodyweight", value: "Bodyweight" },
  { name: "Cables", value: "Cables" },
  { name: "Weights Machine", value: "Weights Machine" },
  { name: "Suspension", value: "Suspension" },
  { name: "Airex", value: "Airex" },
  { name: "Wobble Board", value: "Wobble Board" },
  { name: "Plate", value: "Plate" },
  { name: "Leg Weights", value: "Leg Weights" },
  { name: "Weighted Vest", value: "Weighted Vest" },
  { name: "Dyna Disc", value: "Dyna Disc" },
  { name: "Battle Rope", value: "Battle Rope" },
  { name: "Sandbag", value: "Sandbag" },
  { name: "Resistance Bands", value: "Resistance Bands" },
  { name: "Gliding Disc", value: "Gliding Disc" },
  { name: "Power Wheel", value: "Power Wheel" },
  { name: "Ab Wheel", value: "Ab Wheel" },
  { name: "Medicine Ball", value: "Medicine Ball" },
  { name: "Elliptical", value: "Elliptical" },
  { name: "Rowing Machine", value: "Rowing Machine" },
  { name: "Stairclimber", value: "Stairclimber" },
  { name: "Step Board", value: "Step Board" },
  { name: "Plyo Box", value: "Plyo Box" },
  { name: "Drumstick", value: "Drumstick" },
  { name: "Push Up Bar", value: "Push Up Bar" },
  { name: "Pull Up Bar", value: "Pull Up Bar" },
  { name: "Exercise Bench", value: "Exercise Bench" },
  { name: "Weighted Hoop", value: "Weighted Hoop" },
  { name: "ViPR", value: "ViPR" },
  { name: "Agility Ladder", value: "Agility Ladder" },
  { name: "Agility Box", value: "Agility Box" },
  { name: "Hurdles", value: "Hurdles" },
  { name: "Agility Cones", value: "Agility Cones" },
  { name: "Balance Pad", value: "Balance Pad" },
  { name: "Jump Rope", value: "Jump Rope" },
  { name: "Reaction Ball", value: "Reaction Ball" },
  { name: "Reaction Bell", value: "Reaction Bell" },
  { name: "Heavy Bag", value: "Heavy Bag" },
  { name: "Atlas Stones", value: "Atlas Stones" },
  { name: "Bolsters", value: "Bolsters" },
  { name: "Blankets", value: "Blankets" },
  { name: "Chair", value: "Chair" },
  { name: "Dip bar", value: "Dip bar" },
  { name: "Gymnastic Rings", value: "Gymnastic Rings" },
  { name: "Sleds", value: "Sleds" },
  { name: "Speed Bag", value: "Speed Bag" },
  { name: "Tires", value: "Tires" },
  { name: "Weighted Gloves", value: "Weighted Gloves" },
  { name: "Wrist Weights", value: "Wrist Weights" },
  { name: "Y-bell", value: "Y-bell" },
  { name: "Yoga Belt", value: "Yoga Belt" },
  { name: "Yoga Wheel", value: "Yoga Wheel" },
];

export const timeDuration = [
  { name: 15, value: 15 },
  { name: 30, value: 30 },
  { name: 45, value: 45 },
  { name: 60, value: 60 },
  { name: 75, value: 75 },
];

export const chartData = [
  {
    datums: [
      { x: "0", y: 0, r: undefined },
      { x: "1", y: 9, r: undefined },
      { x: "2", y: 72, r: undefined },
      { x: "3", y: 63, r: undefined },
      { x: "4", y: 6, r: undefined },
      { x: "5", y: 20, r: undefined },
      { x: "6", y: 54, r: undefined },
      { x: "7", y: 57, r: undefined },
      { x: "8", y: 27, r: undefined },
      { x: "9", y: 35, r: undefined },
      { x: "10", y: 63, r: undefined },
      { x: "11", y: 6, r: undefined },
      { x: "12", y: 20, r: undefined },
      { x: "13", y: 54, r: undefined },
      // {x: "14", y: 27, r: undefined},
      // {x: "15", y: 35, r: undefined},
      // {x: "16", y: 63, r: undefined},
      // {x: "17", y: 20, r: undefined},
      // {x: "18", y: 54, r: undefined},
      // {x: "19", y: 57, r: undefined},
      // {x: "20", y: 27, r: undefined},
      // {x: "21", y: 35, r: undefined},
      // {x: "22", y: 63, r: undefined},
      // {x: "23", y: 74, r: undefined},
      // {x: "24", y: 74, r: undefined},
      // {x: "25", y: 63, r: undefined},
      // {x: "26", y: 74, r: undefined},
      // {x: "27", y: 74, r: undefined},
      // {x: "28", y: 74, r: undefined},
      // {x: "29", y: 74, r: undefined},
      // {x: "30", y: 27, r: undefined},
      // {x: "31", y: 35, r: undefined},
      // {x: "32", y: 63, r: undefined},
      // {x: "33", y: 74, r: undefined},
      // {x: "34", y: 35, r: undefined},
      // {x: "35", y: 63, r: undefined},
      // {x: "36", y: 74, r: undefined},
      // {x: "37", y: 35, r: undefined},
      // {x: "38", y: 63, r: undefined},
      // {x: "39", y: 74, r: undefined},
      // {x: "40", y: 31, r: undefined},
      // {x: "41", y: 35, r: undefined},
      // {x: "42", y: 79, r: undefined},
      // {x: "43", y: 81, r: undefined},
      // {x: "44", y: 35, r: undefined},
      // {x: "45", y: 63, r: undefined},
      // {x: "46", y: 74, r: undefined},
      // {x: "47", y: 35, r: undefined},
      // {x: "48", y: 63, r: undefined},
      // {x: "49", y: 74, r: undefined},
      // {x: "50", y: 63, r: undefined},
      // {x: "51", y: 6, r: undefined},
      // {x: "52", y: 20, r: undefined},
      // {x: "53", y: 54, r: undefined},
      // {x: "54", y: 27, r: undefined},
      // {x: "55", y: 35, r: undefined},
      // {x: "56", y: 63, r: undefined},
      // {x: "57", y: 20, r: undefined},
      // {x: "58", y: 54, r: undefined},
      // {x: "59", y: 57, r: undefined},
      // {x: "60", y: 35, r: undefined},
      // {x: "61", y: 63, r: undefined},
      // {x: "62", y: 74, r: undefined},
      // {x: "63", y: 35, r: undefined},
      // {x: "64", y: 63, r: undefined},
      // {x: "65", y: 74, r: undefined},
      // {x: "66", y: 63, r: undefined},
      // {x: "67", y: 6, r: undefined},
      // {x: "68", y: 20, r: undefined},
      // {x: "69", y: 54, r: undefined},
      // {x: "70", y: 27, r: undefined},
      // {x: "71", y: 35, r: undefined},
      // {x: "72", y: 63, r: undefined},
      // {x: "73", y: 20, r: undefined},
      // {x: "74", y: 54, r: undefined},
      // {x: "75", y: 57, r: undefined},
      // {x: "76", y: 27, r: undefined},
      // {x: "77", y: 35, r: undefined},
      // {x: "78", y: 63, r: undefined},
      // {x: "79", y: 20, r: undefined},
      // {x: "80", y: 54, r: undefined},
      // {x: "81", y: 57, r: undefined},
      // {x: "82", y: 63, r: undefined},
      // {x: "83", y: 20, r: undefined},
      // {x: "84", y: 54, r: undefined},
      // {x: "85", y: 57, r: undefined},
      // {x: "86", y: 27, r: undefined},
      // {x: "87", y: 35, r: undefined},
      // {x: "88", y: 63, r: undefined},
      // {x: "89", y: 20, r: undefined},
      // {x: "90", y: 54, r: undefined},
      // {x: "91", y: 57, r: undefined},
      // {x: "92", y: 63, r: undefined},
      // {x: "93", y: 20, r: undefined},
      // {x: "94", y: 54, r: undefined},
      // {x: "95", y: 57, r: undefined},
      // {x: "96", y: 27, r: undefined},
      // {x: "97", y: 35, r: undefined},
      // {x: "98", y: 63, r: undefined},
      // {x: "99", y: 20, r: undefined},
      // {x: "100", y: 54, r: undefined},
      // {x: "101", y: 57, r: undefined},
      // {x: "102", y: 63, r: undefined},
      // {x: "103", y: 20, r: undefined},
      // {x: "104", y: 54, r: undefined},
      // {x: "105", y: 57, r: undefined},
      // {x: "106", y: 27, r: undefined},
      // {x: "107", y: 35, r: undefined},
      // {x: "108", y: 63, r: undefined},
      // {x: "109", y: 20, r: undefined},
      // {x: "110", y: 54, r: undefined},
      // {x: "111", y: 57, r: undefined},
      // {x: "112", y: 63, r: undefined},
      // {x: "113", y: 20, r: undefined},
      // {x: "114", y: 54, r: undefined},
      // {x: "115", y: 57, r: undefined},
      // {x: "116", y: 27, r: undefined},
      // {x: "117", y: 35, r: undefined},
      // {x: "118", y: 63, r: undefined},
      // {x: "119", y: 75, r: undefined}
    ],
    label: "Series 1",
  },
];

export const mediaFile = {};
export const cancelToken = {
  token: null,
  id: null,
};

export const staticVar = {
  1: "one",
  2: "two",
  3: "three",
  app_id: undefined,
  web: "WEB",
  joinedAnotherDevice: "You have joined from another device.",
  streamFromAnotherDevice:
    "You have started streaming from another device. You can only use one device at a time.",
  gallery: "gallery",
  idle: "idle",
  loading: "loading",
  upload: "upload",
  error: "error",
  done: "done",
  process: "process",
  defaultCameraName: "FaceTime HD Camera (Built-in)",
  recordedLive: "RECORDED_LIVE",
  ondemand: "ONDEMAND",
  scheduled: "SCHEDULED",
  waitingRoom: "IN_WAITING_ROOM",
  hangout: "IN_HANGOUT_ROOM",
  ongoing: "IN_ONGOING_ROOM",
  roomStarted: "STARTED",
  info_type: {
    IN_WAITING_ROOM: "WAITING_ROOM_STREAMING",
    IN_HANGOUT_ROOM: "HANGOUT_STREAMING",
    STARTED: "ONGOING_STREAMING",
  },
  waiting: "WAITING",
  ended: "ENDED",
  oneDay: "ONE_DAY",
  daily: "DAILY",
  weekly: "WEEKLY",
  customDay: "CUSTOM_RECURRENCE",
  liveWorkoutPathName: "/LiveActivity",
  manualUpload: "manual-upload",
  bulkUpload: "bulk-upload",
  schedulePasswordProtected: "PASSWORD_PROTECTED",
  public: "PUBLIC",
  mindbody: "mindbody",
  marianatek: "marianatek",
  tribe: "tribe",
  Activity: "Class",
  activity: "class",
  Activities: "Classes",
  activities: "classes",
  bulkDownload:
    "https://tribe-static-content-files.s3.amazonaws.com/whitelabel/Template.csv",
  accessToken: undefined,
  defaultErrorMsg: "Oops! there was an error. Please try again.",
  coachJoined: "Session stopped. Coach has joined the class.",
  askPermission: "Do you want to start streaming from this device?",
  image: "image",
  audio: "audio",
  video: "video",
  fullScreen: "FULL_SCREEN",
  bottomRight: "BOTTOM_RIGHT",
  maxFileSize: {
    image: {
      value: 20,
      text: "MB",
      size: "20MB",
    },
    audio: {
      value: 50,
      text: "MB",
      size: "50MB",
    },
    video: {
      value: 2,
      text: "GB",
      size: "2GB",
    },
  },
  fileAccept: {
    crop_image: "image/x-png, image/png, image/jpg, image/jpeg",
    image: "image/heic, image/x-png, image/png, image/jpg, image/jpeg",
    audio:
      "audio/mp3, audio/mpeg, audio/aac, audio/flac, audio/wav, audio/aiff",
    video:
      "video/mov, video/avi, video/wmv, video/flv, video/x-flv, video/3gp, video/3gpp, video/mp4, video/mpg, video/quicktime",
    all: "video/*, video/mov, video/avi, video/wmv, video/flv, video/x-flv, video/3gp, video/3gpp, video/mp4, video/mpg, video/quicktime, image/heic, image/x-png, image/png, image/jpg, image/jpeg, audio/mp3, audio/aac, audio/flac, audio/mpeg, audio/wav, audio/aiff",
    // video: 'video/avi,video/wmv,video/x-flv,video/3gp,video/mp4,video/mpg,',
  },
  media: {
    upload: "upload",
    myMedia: "myMedia",
    gymMedia: "gymMedia",
    image: "Add image",
    video: "Add video",
    audio: "Add audio",
    library: "Media Assets",
  },
  page: {
    category: "category",
    classByCategory: "classByCategory",
    announcementList: "announcementList",
  },
  metrics: {
    0: "Please enable two (2) metrics to feature on your member app dashboard.",
    1: "Please enable another metric to feature on your member app dashboard.",
    3: "You can only highlight two (2) metrics at once. Please deactivate one to enable this.",
  },
};

export const toolTipInfo = {
  category: "You may select one or more categories for this class.",
  privacySettings:
    "who can access this class - members, password-only access, everyone",
  heartRate: "Allow members to connect heart rate devices for the class.",
  leaderboard: "Select if you want to enable leaderboard for the class.",
  lowLatencyMode:
    "Better video quality class will only have one-way communication and the two-way communication class would have a lower video quality.",
  lowLatencyModeOption: {
    first:
      "With better audio and video sync and less jerky fast movements. Good for classes like dance, but it will have a 3 to 5 second delay in the video stream, like in Twitch streaming.",
    second:
      "Like Zoom - virtually no delay, allowing faster feedback and (optional) 2 way conversations. But the audio and video sync may drift, and fast movements on camera may not look smooth.",
  },
  muteParticipantsByDefault:
    "This allows you to choose if your participants can talk to you during the class or not.",
  classThumb:
    "This is optional. The image you upload here will show on your members' dashboard. If you do not upload an image here, the thumbnail will be taken from the “Class Image” you uploaded cropped from the center with a 5:7 aspect ratio.",
  categoryImage:
    "You can either select an icon from Tribe's list or upload an image for your category.",
};

export const formLabel = {
  category: "Category/ies",
  privacySettings: "Privacy Settings",
  heartRate: "Heart Rate",
  leaderboard: "Leaderboard",
  lowLatencyMode:
    "Would you like to have two-way communication or better video quality during the class?",
  lowLatencyModeOption: {
    first: "Better video quality",
    second: "Real-time video",
  },
  announcementRedirectHeader:
    "Select what happens when this announcement is clicked*",
  announcementRedirectOption: {
    first: "Open a web page",
    second: "Show  a photo or video",
  },
  muteParticipantsByDefault:
    "Do you want the participant to unmute themselves in ongoing room?",
  muteParticipantsByDefaultOption: {
    first: "Yes",
    second: "No",
  },
  classThumb: `${staticVar.Activity} Thumbnail`,
};

export const screenLocation = [
  {
    icon: selectIcon("bottomRightIcon"),
    name: "Bottom Right",
    value: staticVar.bottomRight,
  },
  {
    icon: selectIcon("fullScreenIcon"),
    name: "Full Screen",
    value: staticVar.fullScreen,
  },
  // { icon: selectIcon('high'), name: 'Advanced', value: 'ADVANCED' },
];

export const weekDays = {
  0: { day: "Mon", value: 1 },
  1: { day: "Tue", value: 2 },
  2: { day: "Wed", value: 3 },
  3: { day: "Thu", value: 4 },
  4: { day: "Fri", value: 5 },
  5: { day: "Sat", value: 6 },
  6: { day: "Sun", value: 0 },
};
export const durationKey = ["hour", "minute", "second"];

export const gender = [
  { name: "Male", value: "MALE" },
  { name: "Female", value: "FEMALE" },
  { name: "Other", value: "OTHER" },
];

export const access = {
  location: { show: false, label: "Show Location", value: true },
  deleteMediaClip: { show: false, label: "Delete Media Clip", value: true },
  scheduleMediaClip: {
    show: false,
    label: "Media Clip In Schedule Form",
    value: true,
  },
  templateMediaClip: {
    show: false,
    label: "Media Clip In Template Form",
    value: true,
  },
  recordedMediaClip: {
    show: false,
    label: "Media Clip In Recorded Form",
    value: true,
  },
  ondemandMediaClip: {
    show: false,
    label: "Media Clip In Ondemand Form",
    value: true,
  },
  mediaClip: { show: false, label: "Media Clip Library", value: true },
  image: { show: false, label: "Image (Media Clip)", value: true },
  audio: { show: false, label: "Audio (Media Clip)", value: true },
  video: { show: false, label: "Video (Media Clip)", value: true },
  classlocation: { show: false, label: "Add Location In Class", value: true },
  multiplelocation: {
    show: false,
    label: "Show Multiple Location Option In Location List",
    value: true,
  },
  switchlocation: {
    show: false,
    label: "Show Single Switch Location Option In Location List",
    value: true,
  },
  locationList: {
    show: false,
    label: "Show Location In List With filter",
    value: true,
  },
  defaultUser: { show: true, label: "Default For Class", value: false },
  editMindbody: { show: false, label: "Edit Mindbody", value: true },
  multiSession: { show: false, label: "Use MultiSession", value: true },
  showHangout: { show: false, label: "Show Hangout Class", value: true },
  isActiveAllowedForAllLocation: {
    show: false,
    label: "Allowed For All Location Key",
    value: true,
  },
  videoLimit: {
    show: false,
    label: "Enter video limit",
    value: "9",
    type: "input",
  },
  hangoutRow: {
    show: true,
    label: "Enter number of row",
    value: "2",
    type: "input",
  },
  polling: { show: true, label: "Enter polling url", value: "", type: "input" },
  url: { show: true, label: "Enter url value", value: "", type: "input" },
  urlKey: { show: true, label: "Enter key value", value: "", type: "input" },
  Policy: { show: true, label: "Enter policy Value", value: "", type: "input" },
  "X-Amz-Credential": {
    show: true,
    label: "Enter X-Amz-Credential value",
    value: "",
    type: "input",
  },
  "X-Amz-Algorithm": {
    show: true,
    label: "Enter X-Amz-Algorithm value",
    value: "",
    type: "input",
  },
  "X-Amz-Date": {
    show: true,
    label: "Enter X-Amz-Date value",
    value: "",
    type: "input",
  },
  "X-Amz-Signature": {
    show: true,
    label: "Enter X-Amz-Signature value",
    value: "",
    type: "input",
  },
};

export const location = {
  list: [],
  fetch: false,
};

export const videoResolution = [
  { name: "1920X1080 (16:9)", value: { width: 1920, height: 1080 } },
  { name: "1280X720 (16:9)", value: { width: 1280, height: 720 } },
];

export const noDataText = {
  summary: "There was no participant in this class.",
  hangout: "There was no participant in this class.",
};
export const filterDefaultValue = {
  search: "",
  filter: {
    sortValue: "latestDES",
    mediaType: ["video", "image", "audio"],
    fromDate: null,
    toDate: null,
    coach: [],
    status: [],
  },
};

export const imageFormValue = {
  value: null,
  image: "",
  thumb: "",
  original: "",
  upload: false,
  imgSrc: "",
  imgSrcExt: "",
  crop: "",
  label: "",
};

export const text = {
  plan: "plan",
  coupon: "coupon",
  transactions: "transactions",
  subscriptions: "subscriptions",
};

export const noData = {
  [text.plan]: {
    filter: "There are no Plans.",
    noData: "There are no Plans created yet.",
  },
  [text.coupon]: {
    filter: "There are no Coupons.",
    noData: "There are no Coupons created yet.",
  },
  [text.transactions]: {
    filter: "There are no Transactions.",
    noData: "There are no Transactions.",
  },
  [text.subscriptions]: {
    filter: "There are no Subscriptions.",
    noData: "There are no Subscriptions.",
  },
};

export const billing_frequency = [
  { name: "Daily", value: "1", shortName: "Day", backGroundData: "day" },
  { name: "Weekly", value: "2", shortName: "Week", backGroundData: "week" },
  { name: "Monthly", value: "3", shortName: "Month", backGroundData: "month" },
  {
    name: "Every 3 months",
    value: "3.3",
    shortName: "3 Months",
    backGroundData: "month",
  },
  {
    name: "Every 6 months",
    value: "3.6",
    shortName: "6 Months",
    backGroundData: "month",
  },
  { name: "Yearly", value: "4", shortName: "Year", backGroundData: "year" },
  // { name: "Custom", value: "0", shortName: "", backGroundData: "" },
];
export const validity = [
  { name: "Days", value: "1", shortName: "Day", backGroundData: "day" },
  { name: "Weeks", value: "2", shortName: "Week", backGroundData: "week" },
  { name: "Months", value: "3", shortName: "Month", backGroundData: "month" },
  { name: "Years", value: "4", shortName: "Year", backGroundData: "year" },
];
export const currency = [
  { name: "USD", value: "USD", symbol: "$" },
  { name: "INR", value: "INR", symbol: "₹" },
  { name: "PHP", value: "PHP", symbol: "₱" },
];

export const status = [
  { name: "Active", value: "ACTIVE" },
  { name: "Inactive", value: "INACTIVE" },
];

export const status1 = [
  { name: "Published", value: "true" },
  { name: "Unpublished", value: "false" },
];

export const couponDuration = [
  { name: "Once", value: "once" },
  { name: "Forever", value: "forever" },
  { name: "Multiple Months", value: "repeating" },
];

export const transactionStaus = [
  { name: "Awaiting Payment", value: "AWAITING_PAYMENT" },
  { name: "In Trail", value: "TRIALING" },
  { name: "Active", value: "ACTIVE" },
  { name: "Inactive", value: "INACTIVE" },
  { name: "Canceled", value: "CANCELED" },
  { name: "Pause", value: "PAUSED" },
  { name: "Expired", value: "EXPIRED" },
];
export const paymentTypeOption = [
  {
    name: "Recurring",
    value: "recurring",
    info: "Choosing this will allow your members to automatically renew this package unless they manually cancel the automatic renewal.",
  },
  {
    name: "One-Time",
    value: "one_time",
    info: "Choosing this will charge your members a one-time fee for this package.",
  },
];

export const tableRowsData = {
  [text.plan]: {
    ACTIVE: [
      {
        name: "Name",
        type: "name",
        key: "name",
        sort: true,
        isClickable: true,
      },
      // { name: "Created By", type: "name", key: "created_by" },
      { name: "Date Created", type: "date", key: "created_at", sort: true },
      { name: "Last Modified", type: "date", key: "updated_at" },
      { name: "Visibility", type: "name", key: "visibility" },
      { name: "Purchase", type: "number", key: "total_purchase" },
      {
        name: "STATUS",
        type: "status",
        key: "status",
        show_status_filter: true,
        change_status_filter: true,
        status_optionList: [...status],
      },
      { name: "Duplicate", type: "copy", key: "copy" },
      {
        name: "Edit",
        type: "edit",
        key: "edit",
        disablekey: "edit",
        // disableError: `Sorry, you can't make changes to a live plan. Please create a new one or get in touch with our support.`,
      },
      { name: "Copy Link", type: "copyLink", key: "copyLink" },
    ],
  },
  [text.coupon]: {
    ACTIVE: [
      { name: "Code", type: "secondary_name", key: "code", sort: false },
      { name: "Name", type: "name", key: "name", sort: false },
      { name: "Discount", type: "name", key: "discount", sort: false },
      // { name: "Applicable To", type: "name", key: "redeem_by", sort: false },
      {
        name: "Redemption",
        type: "number",
        key: "times_redeemed",
        sort: false,
      },
      // { name: "Created By", type: "name", key: "created_by" },
      { name: "Date Created", type: "date", key: "created_at", sort: false },
      {
        name: "STATUS",
        type: "status",
        key: "status",
        show_status_filter: true,
        change_status_filter: true,
        status_optionList: [...status1],
      },
      // {
      //   name: "Edit",
      //   type: "edit",
      //   key: "edit",
      //   disablekey: "edit",
      //   // disableError: `Sorry, you can't make changes to a live plan. Please create a new one or get in touch with our support.`,
      // },
      // {
      //   name: "Action",
      //   type: "delete",
      //   key: "delete",
      //   disablekey: "delete",
      //   // disableError: `Sorry, you can't make changes to a live plan. Please create a new one or get in touch with our support.`,
      // },
    ],
  },
  [text.transactions]: {
    ACTIVE: [
      { name: "Sr No.", type: "srNo", key: "", sort: false },
      { name: "MEMBER NAME", type: "name", key: "name", sort: false },
      { name: "Email", type: "email", key: "email", sort: false },
      // { name: "Plan Name", type: "name", key: "planName", sort: false },
      {
        name: "Date of Purchase",
        type: "date",
        key: "purchased_at",
        sort: false,
      },
      {
        name: "Amount",
        type: "name",
        key: "amount",
        sort: false,
      },
      {
        name: "Billing Frequency",
        type: "name",
        key: "billing_frequency",
        sort: false,
      },
      {
        name: "Invoice",
        type: "download",
        key: "invoice",
        sort: false,
      },
      {
        name: "Action",
        type: "refund",
        key: "refund",
        sort: false,
      },
    ],
  },
  [text.subscriptions]: {
    ACTIVE: [
      { name: "Sr No.", type: "srNo", key: "", sort: false },
      {
        name: "Plan Name",
        type: "name",
        key: "planName",
        sort: false,
        isClickable: true,
      },
      // { name: "Payment type", type: "name", key: "payment_type", sort: false },
      {
        name: "PAYMENT TYPE",
        type: "status",
        key: "payment_type",
        show_status_filter: true,
        change_status_filter: false,
        status_optionList: [...paymentTypeOption],
      },
      {
        name: "Amount",
        type: "name",
        key: "amount",
        sort: false,
      },
      {
        name: "Billing Frequency",
        type: "name",
        key: "billing_frequency",
        sort: false,
      },
      {
        name: "Action",
        type: "subscription",
        key: "subscription_status",
        sort: false,
      },
    ],
  },
};
